import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuditQuickComment, QuickComment, StationAudit } from '../../../../models/check-interface';
import { CheckStorageService } from '../../../../services/check-storage.service';

@Component({
  selector: 'lib-detail-image-form',
  templateUrl: './detail-image-form.component.html',
  styleUrls: ['./detail-image-form.component.scss']
})
export class DetailImageFormComponent implements OnInit, OnChanges {

  @Input() stationAudit!: StationAudit;
  @Input() quickComments!: QuickComment[];
  @Input() editable!: boolean;
  @Output() emitClickTextarea: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() emitCreateStationAudit: EventEmitter<string> = new EventEmitter<string>();
  @Output() emitUpdateStationAudit: EventEmitter<StationAudit> = new EventEmitter<StationAudit>();
  @Output() emitClearInterval: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('hiddenOffcanvas') hiddenOffcanvas: ElementRef;

  public auditQuickCommentsSelected: AuditQuickComment[] = [];
  public stationAuditIdSelected!: string;
  public detailImageForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder, 
    private checkStorageService: CheckStorageService, 
    private cdr: ChangeDetectorRef,
  ) {
    this.detailImageForm = this.formBuilder.group({
      roomNumber: [''],
      comment: ['']
    });
  }

  ngOnInit(): void {
    if (this.stationAudit) {
      this.auditQuickCommentsSelected = this.stationAudit.auditQuickComments;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['stationAudit'] && changes['stationAudit'].currentValue) {
      this.stationAudit = changes['stationAudit'].currentValue;

      this.detailImageForm.get('roomNumber')?.setValue(this.stationAudit.roomNumber);
      this.detailImageForm.get('comment')?.setValue(this.stationAudit.comment);

      if(!this.editable) {
        this.detailImageForm.get('roomNumber')?.disable();
        this.detailImageForm.get('comment')?.disable();
      }
      if (this.stationAudit && this.stationAudit.auditQuickComments && this.stationAudit.auditQuickComments.length > 0) {
        this.auditQuickCommentsSelected = this.stationAudit.auditQuickComments;
      } else {
        this.auditQuickCommentsSelected = [];
      }
      this.stationAuditIdSelected = this.stationAudit.id;
    }
  }

  autoGrowTextZone(e: any) {
    if (e.code === 'Enter') {
      e.target.style.height = (26 + e.target.scrollHeight) + "px";
    }
  }

  onFocusOutInputEvent(input: string, value: string) {
    if (input === 'roomNumber') {
      this.stationAudit.roomNumber = value;
    } else if (input === 'comment') {
      this.stationAudit.comment = value;
    } else {
      return;
    }
    this.emitClickTextarea.emit(false);
    this.emitClearInterval.emit(true);

    this.emitClickTextarea.emit(false);
    if (this.stationAudit.id === 'empty-station-audit') {
      this.checkStorageService.postStationAudit(true, this.stationAudit).subscribe((resStationAudit: any) => {
        this.emitCreateStationAudit.emit(resStationAudit);
      });
    } else {
      this.checkStorageService.putStationAudit(this.stationAudit.id, this.stationAudit).subscribe(() => {
        this.emitUpdateStationAudit.emit(this.stationAudit);
      });
    }
  }

  openQuickCommentCanvas() {   }

  setQuickCommentsSelected(items: any) {
    if(!items?.data) return;
    let quickComments = items.data;
    quickComments.forEach((item: AuditQuickComment) => {
      item.stationAuditId = this.stationAudit.id;
    });

    this.stationAudit.auditQuickComments = quickComments;
    this.auditQuickCommentsSelected = quickComments;
    this.checkStorageService.putStationAudit(this.stationAudit.id, this.stationAudit).subscribe(() => { 
      this.cdr.detectChanges();
    });
  }

  clickTextarea() {
    this.emitClickTextarea.emit(true);
  }
}
